module.exports = __webpack_public_path__ + "assets/42f116345bfe3e660c331391898bc306.png";